import * as React from 'react'

import { Box, RadioButton, Text } from '@factorialco/deprecated-design-system'

import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { BUNDLE_YEARLY_DISCOUNT } from 'modules/billing/lib/constants'
import { useF25PricingContext } from 'modules/onboarding/components/Pricing/F25PricingContext'
import { MONTH_PERIOD, YEAR_PERIOD } from 'modules/onboarding/lib/pricing/plans/utils'

const MAX_SEATS = 500

const PeriodAndEmployeeSelector = () => {
  const { isYearly, setPeriod, countryFloor, seats, setSeats } = useF25PricingContext()

  const onChange = (value: string) => {
    const valueToNumber = Number(value)
    if (!valueToNumber) {
      setSeats(countryFloor)
    } else if (valueToNumber > MAX_SEATS) {
      setSeats(MAX_SEATS)
    } else {
      setSeats(valueToNumber)
    }
  }

  return (
    <Box flexDirection="row" justifyContent="spaceBetween" padding="s24" paddingBottom="s0">
      <Box gap="s4">
        <Text size="200" color="grey1000" weight="medium">
          {i18n.t('pricing_plans.billing_period')}
        </Text>
        <Box gap="s4">
          <RadioButton
            onChange={() => setPeriod(MONTH_PERIOD)}
            checked={!isYearly()}
            value={MONTH_PERIOD}
            label={i18n.t('pricing_plans.period_switcher.monthly')}
          />
          <Box flexDirection="row" gap="s8">
            <RadioButton
              onChange={() => setPeriod(YEAR_PERIOD)}
              checked={isYearly()}
              value={YEAR_PERIOD}
              label={i18n.t('pricing_plans.period_switcher.yearly')}
            />
            <Text.Normal size="200" color="viridian1200" weight="medium">
              {i18n.t('pricing_plans.config_plan.save_yearly', {
                discount: BUNDLE_YEARLY_DISCOUNT,
              })}
            </Text.Normal>
          </Box>
        </Box>
      </Box>
      <Box gap="s4" width="min-content">
        <Text size="200" color="grey1000" weight="medium">
          {i18n.t('pricing_plans.employees')}
        </Text>
        <TextField type="number" onChange={onChange} value={seats.toString()} />
      </Box>
    </Box>
  )
}

export default PeriodAndEmployeeSelector
